import { SwitchRolesPageService } from '@/pages/SwitchRoles/services';
import { VApplication, vappContainer } from '../../../../../application';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { logger as log } from '@common/logger';
const MODULE_NAME = 'switchRoles.machines.states.signInUser';
const getSrv = () => {
  return vappContainer.get<SwitchRolesPageService>(
    SwitchRolesPageService.displayName
  );
};
export const getAccessToken = async (context: any, event: any) => {
  const currentState = 'GET_ACCESS_TOKEN';
  const method = 'getAccessToken';
  const storageSrv = StorageModule.getInstance();
  console.log('onrole->');

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      console.log('onrole->');

      const srv = getSrv();
      const content = await srv.agent.getAccessToken(event?.payload);
      log.log(MODULE_NAME, '"GET_ACCESS_TOKEN":', content);
      if (content && content?.accessToken) {
        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SIGN_IN_USER_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
